import React from "react";
import { Tooltip } from "@mui/material";
import FilterOffIcon from "@mui/icons-material/FilterAltOff";
import { useDispatch } from "react-redux";
import { clearAllFilters } from "../../../data/redux/filterSlice";
import { setUrlParams } from "../../../../utils/helpers/setAndGetUrlParams";
import { useSearchParams } from "react-router-dom";

const ClearAllFilters = ({ module }) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <Tooltip title="Clear All Filters" placement="top">
      <button
        className="btn btn-outline-primary btn-sm view-icon"
        // style={{ padding: "0 0.30rem" }}
        onClick={() => {
          dispatch(clearAllFilters({ module }));
          setUrlParams(setSearchParams, "page", 1);
        }}
      >
        <FilterOffIcon />
      </button>
    </Tooltip>
  );
};

export default ClearAllFilters;
